module.exports = __webpack_public_path__ + "img/nottype.449c74cd.png";